import api from 'data/api';

export const loadStatuses = api('GET /api/mobile/finance/lookups/statuses');
